import { render, staticRenderFns } from "./ProjectNew.vue?vue&type=template&id=2a90e034&scoped=true&"
import script from "./ProjectNew.vue?vue&type=script&lang=ts&"
export * from "./ProjectNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90e034",
  null
  
)

export default component.exports